import { RefCallBack } from 'react-hook-form';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import tw from 'tailwind.macro';
import { ChevronIcon } from '../../../images/icons/chevron';
import { colors } from '../../../styles/constants';
import { Icon12 } from '../../Icon';

const StyledSelect = styled.select<SelectProps>`
  ${tw`w-full h-full bg-white rounded-15 py-0 px-medium pr-big border border-solid border-grey-300 outline-none text-text font-bold text-p-medium-m leading-p-medium-m font-bold
focus:border-primary-400         
`}

  appearance: none;

  &:focus {
    box-shadow: 0 0 0 1px ${colors['primary-400']};
  }

  ::placeholder {
    color: ${colors.placeHolders};
  }

  ${({ disabled }) => disabled && tw`bg-grey50 text-placeHolders`}
`;

const Container = styled.div<{ customStyle?: FlattenSimpleInterpolation }>`
  ${tw`relative`}
  height:60px;
  ${({ customStyle }) => customStyle}
`;

const DropdownStyle = css`
  ${tw`absolute`}
  ${Icon12}
  pointer-events: none;
  transform: translateY(-50%) rotate(270deg);

  right: var(--size-medium);
  top: 50%;
`;

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  customStyle?: FlattenSimpleInterpolation;
  inputRef?: RefCallBack;
}

export const Select: React.FC<SelectProps> = (props) => (
  <Container customStyle={props.customStyle}>
    <StyledSelect {...props} ref={props.inputRef} />

    <ChevronIcon color={colors.text} customStyle={DropdownStyle} />
  </Container>
);
